module.exports = __webpack_public_path__ + "static/media/power-atk1.6e11f3b1.png";